<script>
import { BCardSubTitle } from "bootstrap-vue";

export default {
  extends: BCardSubTitle
};
</script>